<div class="absolute inset-0 flex items-center justify-center p-4" role="dialog" aria-modal="true"
    aria-labelledby="auto-decline-explainer-title">
    <button type="button" class="absolute inset-0 bg-zinc-200/40 backdrop-blur-md dark:bg-zinc-900/60"
        (click)="dismiss()" aria-label="Dismiss application review window explainer"></button>

    <section #panel tabindex="-1"
        class="auto-decline-explainer-panel relative z-10 flex max-h-full w-full max-w-xl flex-col overflow-hidden rounded-2xl primary-card-container focus:outline-none">

        <div class="flex shrink-0 items-start justify-between gap-3 border-b border-border px-4 py-3">
            <div class="min-w-0">
                <p
                    class="m-0 inline-flex items-center gap-x-1.5 rounded-full bg-primary/10 px-2 py-0.5 text-xs font-medium text-accent">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-3.5"
                        aria-hidden="true">
                        <path d="M9.9 2.1 8.5 6.4 4.2 7.8l4.3 1.4L9.9 13.5l1.4-4.3 4.3-1.4-4.3-1.4Z" />
                        <path d="M18 14l-.7 2.2L15 17l2.3.8L18 20l.7-2.2L21 17l-2.3-.8Z" />
                    </svg>
                    What's new
                </p>
                <h2 id="auto-decline-explainer-title" class="mt-1 text-base font-semibold text-primary">Applications now
                    have a review window</h2>
                <p class="mt-1 text-sm text-secondary">From now on, for each new brief, applications will expire
                    automatically after a set number of days from the day a creator applies.</p>
            </div>
            <button type="button" (click)="dismiss()"
                class="shrink-0 rounded-full bg-zinc-200 p-1.5 text-primary hover:bg-zinc-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600 dark:bg-zinc-600 dark:hover:bg-zinc-500"
                aria-label="Close application review window explainer">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-5" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <div class="min-h-0 flex-1 overflow-y-auto px-4 py-5">
            <ul role="list" class="m-0 flex flex-col gap-3 p-0">
                <li class="flex items-start gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                        class="mt-0.5 size-4 shrink-0 text-accent" aria-hidden="true">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <p class="m-0 text-sm text-primary">Creators who apply have {{ daysLabel() }} for you to review
                        them.</p>
                </li>
                <li class="flex items-start gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                        class="mt-0.5 size-4 shrink-0 text-accent" aria-hidden="true">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <p class="m-0 text-sm text-primary">After that window, Applied applications are declined
                        automatically.</p>
                </li>
                <li class="flex items-start gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                        class="mt-0.5 size-4 shrink-0 text-accent" aria-hidden="true">
                        <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <p class="m-0 text-sm text-primary">You can no longer act on an expired application.</p>
                </li>
            </ul>
        </div>
        
        <div class="flex w-full justify-center items-center mb-5">
            <img src="https://shout-ugc-assets.s3.eu-west-1.amazonaws.com/other/auto-decline-progress_v4.png" alt="Auto decline explainer" class="w-[90%]">
        </div>

        <div class="flex shrink-0 justify-end border-t border-border px-4 py-3">
            <button type="button" (click)="dismiss()" class="btn-shout btn-shout-sm btn-shout-primary">
                Got it
            </button>
        </div>
    </section>
</div>
